import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { Plus, Trash2, Edit2 } from 'lucide-react';

export function PagesTab({ openPageForm, sitePages, handleDeletePage }) {
  return (
    <>
      <div className="flex justify-end mb-4">
        <Button onClick={() => openPageForm(null)} className="bg-emerald-600 hover:bg-emerald-700 text-white" data-testid="admin-add-page-btn">
          <Plus className="w-4 h-4 mr-2" /> Yeni Sayfa
        </Button>
      </div>
      <div className="bg-white rounded-2xl border border-slate-200 divide-y divide-slate-50">
        {sitePages.map(p => (
          <div key={p.slug} data-testid={`admin-page-${p.slug}`} className="flex items-center gap-4 px-4 py-3">
            <div className="flex-1 min-w-0">
              <div className="font-semibold text-slate-800 flex items-center gap-2">
                {p.title}
                {!p.is_published && <span className="text-[10px] bg-amber-50 text-amber-700 px-1.5 py-0.5 rounded">Taslak</span>}
              </div>
              <Link to={`/sayfa/${p.slug}`} className="text-xs text-slate-400 hover:text-emerald-600">/sayfa/{p.slug}</Link>
            </div>
            <div className="flex gap-1 shrink-0">
              <button onClick={() => openPageForm(p)} className="p-1.5 rounded-lg text-slate-500 hover:bg-slate-100" data-testid={`admin-edit-page-${p.slug}`}><Edit2 className="w-3.5 h-3.5" /></button>
              <button onClick={() => handleDeletePage(p.slug)} className="p-1.5 rounded-lg text-red-500 hover:bg-red-50" data-testid={`admin-delete-page-${p.slug}`}><Trash2 className="w-3.5 h-3.5" /></button>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
